module.exports = __webpack_public_path__ + "static/media/yellowPoppedBalloon.7a189703.svg";